import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconChevronLeftSvg } from "./IconChevronLeftSvg.mjs";
const IconChevronLeft = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconChevronLeftSvg, ...iconProps });
};
export {
  IconChevronLeft
};
